var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnectorsIconColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 28.3333L11.6666 36.6666L11.6666 30L21.6666 30L21.6666 26.6666L11.6666 26.6666L11.6666 20L3.33325 28.3333ZM4.99992 13.3333L8.33325 13.3333L8.33325 9.99996L4.99992 9.99996L4.99992 13.3333ZM11.6666 13.3333L14.9999 13.3333L14.9999 9.99996L11.6666 9.99996L11.6666 13.3333ZM18.3333 13.3333L28.3333 13.3333L28.3333 20L36.6666 11.6666L28.3333 3.33329L28.3333 9.99996L18.3333 9.99996L18.3333 13.3333ZM24.9999 30L28.3333 30L28.3333 26.6666L24.9999 26.6666L24.9999 30ZM31.6666 30L34.9999 30L34.9999 26.6666L31.6666 26.6666L31.6666 30Z",
    fill: "#3AC6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99963 13.3332L8.33297 13.3332L8.33297 9.99983L4.99963 9.99983L4.99963 13.3332ZM11.6663 13.3332L14.9996 13.3332L14.9996 9.99983L11.6663 9.99983L11.6663 13.3332ZM18.333 13.3332L28.333 13.3332L28.333 19.9998L36.6663 11.6665L28.333 3.33317L28.333 9.99983L18.333 9.99983L18.333 13.3332Z",
    fill: "#1576B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectorsIconColor);
export default __webpack_public_path__ + "static/media/connectors-icon-color.b1e71936.svg";
export { ForwardRef as ReactComponent };